// src/config/env.js

export const config = {
  // Google OAuth
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,

  // API
  apiBaseUrl: process.env.REACT_APP_API_URL,

  // Company Info
  companyName: process.env.REACT_APP_COMPANY_NAME || 'ScalePulse',

  // QuickBooks
  quickBooksClientId: process.env.REACT_APP_INTUIT_CLIENT_ID,
  quickBooksRedirectUri: process.env.REACT_APP_INTUIT_REDIRECT_URI,

  // Footer
  sidebarFooterUrl: process.env.REACT_APP_FOOTER_URL,

  // Environment
  environment: process.env.NODE_ENV,
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
};

// Validate required environment variables
const requiredEnvVars = [
  'REACT_APP_GOOGLE_CLIENT_ID',
  'REACT_APP_API_URL',
];

requiredEnvVars.forEach((varName) => {
  if (!process.env[varName]) {
    console.error(`❌ Missing required environment variable: ${varName}`);
  }
});
